import React, {Component} from 'react';
import {withAdminAccountContext} from "../../../contexts/AdminAccountContext";
import {withRouter} from "react-router-dom"
import {Form} from "react-bootstrap";
import moment from "moment";
import Calendar from "react-calendar";
import styles from "../../../components/ui/PageTitle/PageTitle.module.css";
class RoundBetWinningResultNumber extends Component {
    constructor(props) {
        super(props);
        this.state = {
            round_number: "",
            account_code: "",
            start_date: null,
            end_date: null,
            datepicker: false,
            search: props.searchData
        }
    }

    onSearchRoundNumber = (e) => {
        this.setState({
            search: {
                ...this.state.search,
                round_number: e.target.value
            }
        }, () => {
            this.props.doUpdateSearchData(this.state.search)
        });
    }

    onSearchAccountId = (e) => {
        this.setState({
            search: {
                ...this.state.search,
                account_code: e.target.value
            }
        }, () => {
            this.props.doUpdateSearchData(this.state.search)
        });
    }
    onChangeDate = (date) => {
        this.setState({
            date,
            search: {
                ...this.state.search,
                start_date: (date)?moment(new Date(date[0])).format('YYYY-MM-DD'):null,
                end_date: (date)?moment(new Date(date[1])).format('YYYY-MM-DD'):null
            },
            datepicker: false
        }, () => {
            this.props.doUpdateSearchData(this.state.search)
        })
    }
    handleSearch = () => {
        let search = this.state.search;
        search = {
            ...search,
            ...((search.round_number !== "") && { has_empty: true })
        }
        this.props.refTable.search(search)
    }

    render() {
        return (
            <React.Fragment>
                <div className={styles.SearchBox}>
                    <Form.Control
                        aria-describedby="basic-addon2"
                        className={"search-item"}
                        name={"account_code"}
                        onChange={this.onSearchAccountId}
                        style={document.getElementById('table-cell-05')?{ width: document.getElementById('table-cell-05').offsetWidth }:null}
                        placeholder={"ACCOUNT ID"}
                        value={this.state.search.account_code}
                    />
                    <Form.Control
                        aria-describedby="basic-addon2"
                        className={"search-item"}
                        name={"round_number"}
                        onChange={this.onSearchRoundNumber}
                        style={document.getElementById('table-cell-04')?{ width: document.getElementById('table-cell-04').offsetWidth }:null}
                        placeholder={"ROUND NUMBER"}
                        value={this.state.search.round_number}
                    />
                    <div className={"search-item"} style={document.getElementById('table-cell-03')?{ width: document.getElementById('table-cell-03').offsetWidth }:null}>
                        <a href={"javascript:void(0)"} onClick={(e) => this.setState({ datepicker: !this.state.datepicker })}>
                            <React.Fragment>
                                {this.state.search.start_date?<span style={{ fontSize: '11px' }}>{moment(new Date(this.state.search.start_date)).format('MMM D, YY')}</span>:"DATE"}
                                {this.state.search.end_date && this.state.search.end_date !== this.state.search.start_date?<span style={{ fontSize: '11px' }}>-{moment(new Date(this.state.search.end_date)).format('MMM D, YY')}</span>:""}
                            </React.Fragment>
                        </a>
                        {this.state.datepicker && <div className={"float-calendar"}><Calendar value={this.state.date} onChange={this.onChangeDate} selectRange={true}/></div>}
                    </div>

                    <Form.Control
                        as={"select"}
                        className={"search-item"}
                        name={"status"}
                        value={this.state.search.time_hour}
                        style={document.getElementById('table-cell-02')?{ width: document.getElementById('table-cell-02').offsetWidth }:null}
                        onChange={(e) => {
                            this.setState({
                                search: {
                                    ...this.state.search,
                                    time_hour: e.target.value
                                }
                            }, () => {
                                this.props.doUpdateSearchData(this.state.search)
                            })
                        }}

                    >
                        <option value={""}>TIME</option>
                        {[...Array(24).keys()].map((h) => {
                            return <option value={(h < 10)?`0${h}`:h}>{(h < 10)?`0${h}`:h}:00</option>
                        })}

                    </Form.Control>
                    <button className={"btn btn-account search-item"} type={"submit"} onClick={this.handleSearch}
                        style={document.getElementById('table-cell-01')?{ width: document.getElementById('table-cell-01').offsetWidth }:null}
                    >Search</button>

                </div>

            </React.Fragment>
        )
    }
}

export default withRouter(withAdminAccountContext(RoundBetWinningResultNumber));